import { StatSegmentRegistry } from '@/types/stats/StatSegmentRegistry.ts';

/**
 * Skąd wzięła się rezerwacja. Źródła się **nakładają** — jedna rezerwacja bywa
 * i powracającym klientem, i kodem promocyjnym — więc mianownik udziałów jedzie
 * osobno, w `total` rozbicia.
 */
export enum BookingSourceKey {
  RETURNING_CLIENT = 'RETURNING_CLIENT',
  SIBLING = 'SIBLING',
  PROMO_CODE = 'PROMO_CODE',
  DIRECT = 'DIRECT',
}

export const BOOKING_SOURCE_REGISTRY: StatSegmentRegistry = {
  [BookingSourceKey.RETURNING_CLIENT]: {
    label: 'Powracający klienci',
    tone: 'success',
  },
  [BookingSourceKey.SIBLING]: { label: 'Rodzeństwo', tone: 'info' },
  [BookingSourceKey.PROMO_CODE]: { label: 'Kod promocyjny', tone: 'warning' },
  [BookingSourceKey.DIRECT]: { label: 'Bez źródła', tone: 'neutral' },
};
